// GSAP
document.addEventListener("DOMContentLoaded", (event) => {
// Enregistrement du plugin ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);
  //card parallax effect
  const imageContainers = document.querySelectorAll(".slide-image-cover-container");
  // Paralax
  imageContainers.forEach((imageContainer) => {
    gsap.to(imageContainer, {
      yPercent: -20,
      ease: "none",
      scrollTrigger: {
        trigger: imageContainer.parentNode, // Utilisation du parent comme déclencheur
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
    });
});

});
